import { createAction, props } from '@ngrx/store';

export const SET_SELECTED_ORDER_DATA = '[selected order] Set selected order data';
export const SET_SELECTED_ORDER_FLIGHT_IDENTIFIER = '[selected order] Set selected order flight identifier';

export const setSelectedOrderData = createAction(SET_SELECTED_ORDER_DATA, props<{ dossierNumber: string }>());
export const setSelectedOrderFlightIdentifier = createAction(
  SET_SELECTED_ORDER_FLIGHT_IDENTIFIER,
  props<{ flightDetailsIdentifier: string }>()
);
